import { BottomBox } from "@/components/molecules/";

const pages = ["about", "terms", "privacy", "contact"] as const;
const labels: Record<(typeof pages)[number], string> = {
  about: "About",
  terms: "Terms of Service",
  privacy: "Privacy Policy",
  contact: "Contact",
};

const FooterNavigation = () => {
  const handleChange = (newValue: number) => {
    const page = pages[newValue];

    if (page) {
      window.location.href = `/${page}`;
    }
  };

  return (
    <BottomBox
      pages={pages}
      labels={labels}
      onLinkTap={index => handleChange(index)}
    />
  );
};

export default FooterNavigation;
